import React from "react";
import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const ReturnOfGOodsFromVendorsList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.ReturnOfGoodsFromVendors} />
        </>
    );
}

export default ReturnOfGOodsFromVendorsList;